<div class="edito" [formGroup]="editoForm">
  <h2 class="space-v-l">{{ 'SUMMARY' | translate }}</h2>
  <editor id="RecipesModifyClassificationEditoHookTxt" formControlName="summary" [init]="initOptions"></editor>
</div>

<div class="buttons-container">
  <button class="btn-warn" mat-raised-button (click)="reset()" [disabled]="editoForm.pristine">
    {{ 'EDITO.RESET' | translate }}
  </button>
  <button class="btn-submit space-l-s" mat-raised-button (click)="save()" [disabled]="editoForm.invalid || editoForm.pristine">
    {{ 'SAVE' | translate }}
  </button>
</div>
